<h1 mat-dialog-title [attr.data-cy]="'vhpadhpad_h1_1_4_'">HIT PIN aktualisieren (1/{{ data.length }})</h1>
<div mat-dialog-content>
    <div class="one-row">
        <div style="width: 100px; text-align: center">
            <mat-icon [attr.data-cy]="'vhpadhpad_mat-icon_1_2_'">info</mat-icon>
        </div>
        <span style="color: gray"
            >Anscheinend haben Sie ihre PIN in HI-Tier ge&auml;ndert! Bitte geben Sie hier Ihre aktuelle HI-Tier PIN
            ein, damit VETVET die HI-Tier Schnittstelle benutzen kann. Vielen Dank!</span
        >
    </div>
    <h2>{{ aktuellerKunde?.bezeichnung_final }}</h2>
    <h3>{{ aktuellerKunde?.zusatz_final }}</h3>
    <h3>VVVO: {{ aktuellerKunde?.vvvo }}</h3>
    <mat-form-field style="width: 100%">
        <mat-label>Aktuelle HIT PIN eingeben</mat-label>
        <input
            [type]="visible ? 'text' : 'password'"
            matInput
            [formControl]="pinCtrl"
            [attr.data-cy]="'vhpadhpad_input_1_1_'"
        />
        <button matSuffix mat-icon-button (click)="visible = !visible" [attr.data-cy]="'vhpadhpad_button_1_0_'">
            <mat-icon [attr.data-cy]="'vhpadhpad_mat-icon_2_2_'">{{
                visible ? "visibility_off" : "visibility"
            }}</mat-icon>
        </button>
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-flat-button color="warn" (click)="removeVVVO()" [attr.data-cy]="'vhpadhpad_button_2_0_'"
        >Diesen Betrieb löschen</button
    >
    <span class="spacer"></span>
    <button mat-stroked-button (click)="close()" [attr.data-cy]="'vhpadhpad_button_close_0_'">Schlie&szlig;en</button>
    <button
        mat-flat-button
        color="accent"
        (click)="pinAktualisieren()"
        [disabled]="!pinCtrl.valid"
        [attr.data-cy]="'vhpadhpad_button_3_0_'"
        >PIN aktualisieren
    </button>
</div>
